<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';

  import LoadingPage from '../components/templates/LoadingPage.svelte';

  const navigate = useNavigate();

  async function handleFlow() {
    navigate('/customer-acquisition');
  }
</script>

<LoadingPage on:complete={handleFlow} />

<style lang="scss">
</style>
